import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function gsapParallax() {
  gsap.registerPlugin(ScrollTrigger);

const innerBlocks = document.querySelectorAll('.site-colour-block .inner-block');

innerBlocks.forEach(block => {
  gsap.to(block, {
    '--parallax-y': '100px', // Adjust as needed
    '--parallax-y-': '-100px',
    ease: "none",
    scrollTrigger: {
      trigger: block,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
    }
  });
});
}